import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { registerNewUser } from "../../services";
import { notify } from "../actions/CommonActions";
import { MdCancel } from "react-icons/md";
import { getSingleRoles, updateSingleRoles } from "../../services";
import { useQuery } from "react-query";
// import { AuthContext } from "../../helpers/AuthContext";

export const UpdateRoleModal = ({
  showUser,
  setShowUser,
  toggleShowUser,
  refetch,
  roleName,
  roles,
  role
}) => {
  const [register, setRegister] = useState({
    name: "",
  });
  const [permissions, setPermissions] = useState([]);
  const [isRegistering, setIsRegistering] = useState(false);
  const [loading, setLoading] = useState(false)
  //   const { roles, user } = useContext(AuthContext);

  useEffect(()=>{
    const singleRole = async() =>{
      setLoading(true)
      if(showUser){
      await getSingleRoles(roleName?.id)
      .then((res) => {
        // setShowUser(false);
        if(res?.data?.permissions == null){
          setPermissions([])
        }
        else{
        setPermissions(res?.data?.permissions)
        }
        // console.log('res single ',res);
        })
      }
      setLoading(false)
    }
    singleRole()
  },[showUser])


  const navigate = useNavigate();
  const handleRegisterChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setRegister({ ...register, [name]: value });
  };


  const handleRoleChange = async (e) => {
    const target = e.target.value;
    // console.log('target ', target);
    if(!permissions.includes(target)){
    setPermissions((prevPermissions) => [...prevPermissions, target]);
    }
    // console.log("register ", permissions);
  };

  const removePermission = (i) =>{
    const newPermissions = [...permissions];
    newPermissions.splice(i, 1);
    setPermissions(newPermissions)
  }

  const updateRoleCall = (values) => {
    setIsRegistering(true);
    // e.preventDefault();
    updateSingleRoles(roleName?.id , values)
      .then((res) => {
        console.log('res ',res);
        notify("success", "Role updated successfully.", res?.message);
        // setShowUser(false);
        setPermissions([])
        setIsRegistering(false);
        toggleShowUser()
        refetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsRegistering(false);
      });
  };

  return (
    <Modal
      show={showUser}
      onHide={toggleShowUser}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Update Role</Modal.Title>
        </div>
      </Modal.Header>
      {loading? 
      <p>Loading...</p>:
      <Modal.Body>
        <div>
          <Form className="d-flex flex-column gap-3">
            <Row>
              <Form.Group as={Col}>
                <Form.Label>Name</Form.Label>
                <Form.Control name="name" value={roleName?.name} />
              </Form.Group>
            </Row>
            <Form.Group>
              <Form.Label>Permissions</Form.Label>
              <Form.Select name="permissions" onChange={handleRoleChange}>
                <option></option>
                {roles?.data?.map((role, index) => {
                  return (
                    <option key={index} value={role}>
                      {role}
                    </option>
                  );
                })}
              </Form.Select>
              {/* <Form.Control name="roleId" onChange={handleRegisterChange} /> */}
            </Form.Group>

            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
              }}
            >
              {permissions?.map((item, index)=>
              <p
              key={index}
                style={{
                  background: "#0075C9",
                  padding: "5px 10px",
                  color: "white",
                  borderRadius: "20px",
                }}
              >
                {item} <MdCancel onClick={()=> removePermission(index)} />
              </p>
              )}
            </div>
            {/* <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                name="password"
                type="password"
                onChange={handleRegisterChange}
              />
            </Form.Group> */}

            <Button
              onClick={() => {
                //   e.preventDefault();
                const sentData = {
                    permissions: permissions
                }
                updateRoleCall(sentData);
              }}
              className="w-100"
              style={{ backgroundColor: "#007dcc" }}
              disabled={isRegistering}
            >
              {isRegistering ? "Submitting..." : "Submit"}
            </Button>
          </Form>
        </div>
      </Modal.Body>}
      {/* <Modal.Footer>
        <Button
          style={{
            backgroundColor: "#007dcc",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          Search
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};
